import { render } from "./KeeperROI.vue?vue&type=template&id=fad7de20&scoped=true"
import script from "./KeeperROI.vue?vue&type=script&lang=js"
export * from "./KeeperROI.vue?vue&type=script&lang=js"

import "./KeeperROI.vue?vue&type=style&index=0&id=fad7de20&scoped=true&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad7de20"]])

export default __exports__